var elementProto = Object.create(HTMLElement.prototype);

var _handleSwitch = function(e) {
	var self = this;
    var input = this.getElementsByTagName('input')[0];

    if (!input.checked) {
        input.removeAttribute('checked');
    } else {
        input.setAttribute('checked', '');
    }
}

elementProto.createdCallback = function() {
	this.handleSwitch = _handleSwitch.bind(this);
}
elementProto.attachedCallback = function() {
    var input = this.getElementsByTagName('input')[0];

	input.addEventListener('change', this.handleSwitch);
}
elementProto.detachedCallback = function() {
}

document.registerElement('switch-component', {
	prototype: elementProto
});